module.exports = __webpack_public_path__ + "media/images/send-button-b42f0e388546e3bd3922ea5aecbb077c.svg";